import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PageInfo from './page_info';
import SidebarSearch from 'components/search_sidebar/sidebar_search';

export default class SearchPageFilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    hidePageData: PropTypes.bool,
    newDesignSystem: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number,
      itemCount: PropTypes.number,
      itemSingularLabel: PropTypes.string,
      pageSize: PropTypes.number,
      totalCount: PropTypes.number
    }),
    renderContainerAsDiv: PropTypes.bool,
    searchFormGroupChildren: PropTypes.any,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    onSearchChange: PropTypes.func
  };

  static defaultProps = {
    newDesignSystem: false,
    renderContainerAsDiv: true,
    searchPlaceholder: 'Search'
  };

  render() {
    const { children, newDesignSystem, renderContainerAsDiv } = this.props;

    const ContainerElement = renderContainerAsDiv ? 'div' : React.Fragment;

    return (
      <ContainerElement>
        <div className={classNames('filters-row', { 'ds-filter-row': newDesignSystem })}>
          {this.renderSearchBar()}
          {children}
        </div>
        {this.renderPageCount()}
      </ContainerElement>
    );
  }

  shouldRenderSearchBar() {
    return typeof this.props.onSearchChange === 'function';
  }

  renderSearchBar() {
    const { newDesignSystem, searchPlaceholder, searchText, onSearchChange } = this.props;

    if (!this.shouldRenderSearchBar()) return null;

    return (
      <SidebarSearch
        name="search_text"
        newDesignSystem={newDesignSystem}
        placeholder={searchPlaceholder}
        value={searchText}
        onChange={onSearchChange}
      >
        {this.props.searchFormGroupChildren}
      </SidebarSearch>
    );
  }

  renderPageCount() {
    if (!this.props.pageData) return null;

    // Can be made invisible (not display: none) to prevent elements from jumping around on hide
    return (
      <div className="hidden-xs hidden-sm d-inline-block pull-right">

        <PageInfo
          className={classNames('page-count hidden-xs hidden-sm', { invisible: this.props.hidePageData })}
          name="page_count"
          {...this.props.pageData}
        />
      </div>
    );
  }
}
